"use client";

import React from "react";
import { Map, ShieldCheck, Compass, Camera, Aperture, Briefcase, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
const mapFeatures = [{
  icon: Map,
  title: "Authentic Craft",
  desc: "We connect you with local masters from the hills of Medellin to the coast of Cartagena."
}, {
  icon: ShieldCheck,
  title: "Cultural Roots",
  desc: "Itineraries that honor the heritage and traditions of every land we help you explore."
}, {
  icon: Compass,
  title: "Collective Discovery",
  desc: "A philosophy of leaving every place better than we found it—for the land and the traveler."
}];
const lensFeatures = [{
  icon: Camera,
  title: "Boutique Curation",
  desc: "Hand-selected stays from the shores of Naxos to the hidden gems of Palomino."
}, {
  icon: Aperture,
  title: "Global Expertise",
  desc: "Benefit from 70 years of combined experience guiding your journey across the globe."
}, {
  icon: Briefcase,
  title: "The PS Way",
  desc: "A philosophy of immersive luxury, raw discovery, and deeply connected local culture."
}];
export default function TheLensTheMap() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="117220" id="the-art-of-experience" ref={sectionRef} className="relative w-full bg-background text-foreground overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[800px]">
        
        {}
        <div className="relative flex flex-col justify-center p-8 py-16 lg:p-16 xl:p-24 bg-accent/30 overflow-hidden group">
          {}
          <div className="absolute inset-0 opacity-40 bg-[url(/img/artisan_colombia_bw.jpg)] bg-cover bg-center mix-blend-overlay transition-transform duration-1000 group-hover:scale-105 pointer-events-none" />
          
          <div className={`relative z-10 flex flex-col h-full justify-center max-w-md mx-auto lg:mx-0 lg:ml-auto lg:mr-12 transition-all duration-1000 delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            {}
            <h2 className="font-serif text-5xl lg:text-[4rem] leading-none text-secondary mb-10 lg:translate-x-16 lg:z-30 relative text-left">
              The Soul
            </h2>

            {}
            <div className="bg-background/80 backdrop-blur-md border border-secondary/20 rounded-sm p-8 shadow-xl">
              <ul className="space-y-8">
                {mapFeatures.map((feature, i) => <li key={i} data-index={i} className="flex items-start gap-4">
                    <div className="p-3 rounded-full bg-secondary/10 text-secondary shrink-0">
                      <feature.icon className="w-6 h-6" />
                    </div>
                    <div>
                      <h3 className="font-default font-semibold text-foreground text-lg tracking-tight">
                        {feature.title}
                      </h3>
                      <p className="font-sans text-muted-foreground mt-1 leading-relaxed">
                        {feature.desc}
                      </p>
                    </div>
                  </li>)}
              </ul>
              
              <Button asChild className="mt-10 w-full sm:w-auto group/btn bg-primary text-primary-foreground hover:bg-secondary transition-colors">
                <Link to="#">
                  Our Story
                  <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover/btn:translate-x-1" />
                </Link>
              </Button>
            </div>
          </div>
        </div>

        {}
        <div className="relative flex flex-col justify-center p-8 py-16 lg:p-16 xl:p-24 bg-card/40 text-foreground overflow-hidden group">
          {}
          <div className="absolute inset-0 opacity-5 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634877/img/texture_gold_dust.png)] bg-cover bg-center transition-transform duration-1000 group-hover:scale-105 pointer-events-none" />
          
          <div className={`relative z-10 flex flex-col h-full justify-center max-w-md mx-auto lg:mx-0 lg:mr-auto lg:ml-12 transition-all duration-1000 delay-300 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            {}
            <h2 className="font-serif text-5xl lg:text-[3.5rem] leading-tight text-secondary mb-10 lg:-translate-x-16 lg:z-30 relative text-left lg:text-right">
              Not just destinations — experiences
            </h2>

            {}
            <div className="bg-card/60 backdrop-blur-md border border-secondary/20 rounded-sm p-8 shadow-2xl">
              <ul className="space-y-8">
                {lensFeatures.map((feature, i) => <li key={i} data-index={i} className="flex items-start gap-4">
                    <div className="p-3 rounded-full bg-secondary/10 text-secondary shrink-0">
                      <feature.icon className="w-6 h-6" />
                    </div>
                    <div>
                      <h3 className="font-default font-semibold text-foreground text-lg tracking-tight">
                        {feature.title}
                      </h3>
                      <p className="font-sans text-muted-foreground mt-1 leading-relaxed">
                        {feature.desc}
                      </p>
                    </div>
                  </li>)}
              </ul>

              <Button asChild className="mt-10 w-full sm:w-auto bg-primary text-primary-foreground hover:bg-secondary transition-colors group/btn">
                <Link to="#">
                  Discover More
                  <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover/btn:translate-x-1" />
                </Link>
              </Button>
            </div>
          </div>
        </div>

      </div>

      {}
      <div className="hidden lg:block absolute left-1/2 top-0 bottom-0 w-px bg-secondary/30 z-20 mix-blend-overlay" />
    </section>;
}